var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7143 13.2857L13.2857 13.2857L13.2857 19.7143C13.2857 20.4214 12.7071 21 12 21C11.2929 21 10.7143 20.4214 10.7143 19.7143V13.2857H4.28571C3.57857 13.2857 3 12.7071 3 12C3 11.2929 3.57857 10.7143 4.28571 10.7143H10.7143V4.28571C10.7143 3.57857 11.2929 3 12 3C12.7071 3 13.2857 3.57857 13.2857 4.28571V10.7143H19.7143C20.4214 10.7143 21 11.2929 21 12C21 12.7071 20.4214 13.2857 19.7143 13.2857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.04ecb9adc85d08a8ab261d58a533d1bf.svg";
export { ForwardRef as ReactComponent };